<template>
    <div class="col-lg-4 m-auto">
        <card :title="$t('edit_user')">
            <form @submit.prevent="saveUser" @keydown="form.onKeydown($event)">
                <!-- Name -->
                <div class="form-group">
                    <label>{{ $t('name') }}</label>
                    <input v-model="form.name"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                        class="form-control"
                        type="text"
                        name="name">
                    <has-error :form="form"
                        field="name" />
                </div>

                <!-- Email -->
                <div class="form-group">
                    <label>{{ $t('email') }}</label>
                    <input v-model="form.email"
                        :class="{ 'is-invalid': form.errors.has('email') }"
                        class="form-control"
                        type="email"
                        name="email">
                    <has-error :form="form"
                        field="email" />
                </div>

                <!-- Company -->
                <div class="form-group">
                    <label>{{ $t('company') }}</label>
                    <select v-model="form.company"
                        :class="{ 'is-invalid': form.errors.has('company') }"
                        class="form-control"
                        name="company">
                        <option value="" selected>{{ $t('select_company') }}</option>
                        <option v-bind:key="company.id" v-for="company in companies" v-bind:value="company.id">
                            {{ company.name }}
                        </option>
                    </select>
                    <has-error :form="form"
                        field="company" />
                </div>

                <!-- Company -->
                <div class="form-group">
                    <label>{{ $t('role') }}</label>
                    <select v-model="form.role"
                        :class="{ 'is-invalid': form.errors.has('role') }"
                        class="form-control"
                        name="role">
                        <option value="" selected>{{ $t('select_role') }}</option>
                        <option v-bind:key="key" v-for="(role,key) in roles" v-bind:value="key">
                            {{ role }}
                        </option>
                    </select>
                    <has-error :form="form"
                        field="company" />
                </div>

                <!-- Active -->
                <div class="form-group">
                    <label>{{ $t('active') }}</label>
                    <select v-model="form.active"
                        :class="{ 'is-invalid': form.errors.has('role') }"
                        class="form-control"
                        name="role">
                        <option v-bind:key="key" v-for="(value,key) in active" v-bind:value="key">
                            {{ value }}
                        </option>
                    </select>
                    <has-error :form="form"
                        field="company" />
                </div>
            </form>
            <div class="text-right" slot="footer">
                <button class="btn btn-primary" @click="saveUser">{{ $t('send') }}</button>
            </div>
        </card>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Form from "vform";

export default {
    data() {
        return {
            loading: false,
            users: null,
            companies : null,
            error: null,
            roles : {
                1 : 'Kund',
                2 : 'Kundgranskare',
                3 : 'Redaktör',
                4 : 'Administratör'
            },
            active : {
                0 : 'Nej',
                1 : 'Ja',
            },
            form: new Form({
                name: "",
                email: "",
                company: "",
                role: "" ,
                active: 0,
            })
        };
    },
    created() {
        this.fetchData(this.id);
    },
    computed : {
        id(){
            return this.$route.params.id ? this.$route.params.id : false;
        }
    },
    methods: {
        userReset(){
            this.editUser = 0;
        },
        async fetchData(id) {
            if(id) this.fetchUser(id);
            this.fetchCompanies();
        },
        async fetchUser(id){
            const { data } = await axios.get("/api/user/" + id);
            
            this.form.name = data.name;
            this.form.email = data.email;
            this.form.company = data.company_id;
            this.form.role = data.role;
            this.form.active = data.active;
        },
        async fetchCompanies(){
            let { data } = await axios.get("/api/company")
            this.companies = data;
        },
        async saveUser() {
            if(this.id){
                const { data } = await this.form.patch("/api/user/" + this.id);
            } else {
                const { data } = await this.form.post("/api/register");
            }

            this.form.reset();
            this.$router.push({ name: 'admin.users' });
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/users/form.vue